"use client";
import { createContext, useContext } from "react";

/**
 * Cursul BNR al zilei, în antetul aplicației (02.10.2026, userul: „să avem cursul BNR zilnic afișat în headerul aplicației,
 * pentru că vom raporta toate rapoartele și la lei, și la euro”). Root layout-ul îl citește pe server (ultimul curs din
 * `BnrRate`, ținut în memorie câteva minute) și îl pune aici; `AppShell` îl arată lângă firma activă.
 */
export type CursAntet = { eur: number; usd: number | null; zi: string } | null;
const CursContext = createContext<CursAntet>(null);

export function CursProvider({ curs, children }: { curs: CursAntet; children: React.ReactNode }) {
  return <CursContext.Provider value={curs}>{children}</CursContext.Provider>;
}
export const useCursBnr = (): CursAntet => useContext(CursContext);

/** „EUR 5,3447” în bara de sus; la trecerea cu mouse-ul: ziua cursului și dolarul. */
export function CursBnrAntet() {
  const c = useCursBnr();
  if (!c) return null;
  const f = (v: number) => v.toLocaleString("ro-RO", { minimumFractionDigits: 4, maximumFractionDigits: 4 });
  const zi = `${c.zi.slice(8, 10)}.${c.zi.slice(5, 7)}.${c.zi.slice(0, 4)}`;
  return (
    <div className="hidden h-full items-center gap-2 border-l border-white/10 px-3 text-[12px] leading-tight md:flex" title={`Curs BNR din ${zi}: 1 EUR = ${f(c.eur)} lei${c.usd ? ` · 1 USD = ${f(c.usd)} lei` : ""}`}>
      <span className="opacity-60">BNR {zi.slice(0, 5)}</span>
      <span className="tnum font-semibold">EUR {f(c.eur)}</span>
      {c.usd != null && <span className="tnum hidden opacity-80 lg:inline">USD {f(c.usd)}</span>}
    </div>
  );
}
